import * as validators from "./validators";
import * as utils from "./utils";

const OfferService = {
    utils,
    validators
}

export default OfferService;